export const replacePlaceholders = (
  originalText: string | undefined,
  placeholders: [string | undefined, string | undefined][]
) =>
  placeholders?.reduce(
    (text, [placeholder, placeholderText]) =>
      text?.replace(placeholder || '', placeholderText || ''),
    originalText
  )

export const replaceXFPlaceholders = (
  originalText: string,
  [placeholder, placeholderText]: [string, string]
) => originalText.replace(new RegExp(`\\${placeholder}`, 'g'), placeholderText)

export const replacePlaceholderById = (
  originalText: string,
  [componentId, placeholderText]: [string, string | undefined]
): string => {
  if (!placeholderText) {
    return originalText
  }

  const componentRegex = new RegExp(
    `("id":"${componentId}".*?"text":)"(.*?)"`,
    's'
  )

  return originalText.replace(componentRegex, `$1"${placeholderText}"`)
}
